import { Grid, Step, StepLabel, Stepper, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import React from 'react';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
  },
  stepperButtons: {
    textAlign: 'right',
  },
  button: {
    marginRight: theme.spacing(1),
  },
  instructions: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  stepLabel: {
    textAlign: 'center',
    textTransform: 'uppercase',
  },
  stepperWrapper: {
    backgroundColor: 'transparent',
  },
}));

function CustomStepper({ steps, activeStep }) {
  const classes = useStyles();

  return (
    <>
      <Grid container direction="row" justify="space-between" alignItems="center">
        <Grid item xs={12}>
          <Stepper alternativeLabel activeStep={activeStep - 1} className={classes.stepperWrapper}>
            {steps.map(step => {
              const labelProps = {};
              if (step.error !== '') {
                labelProps.optional = (
                  <Typography variant="caption" color="error">
                    {step.error}
                  </Typography>
                );
                labelProps.error = true;
              }
              return (
                <Step key={step.title}>
                  <StepLabel {...labelProps} className={classes.stepLabel}>
                    {step.title}
                  </StepLabel>
                </Step>
              );
            })}
          </Stepper>
        </Grid>
      </Grid>
      <div>{activeStep <= steps.length && steps[activeStep - 1].component}</div>
    </>
  );
}

export { CustomStepper };
